import { useCallback, useState } from 'react';
import type { UseRichTextControllerProps, UseRichTextControllerReturn } from './types';

export function useRichTextController({
  defaultValue = '',
  onSave,
  onCancel,
}: UseRichTextControllerProps = {}): UseRichTextControllerReturn {
  const [value, setValue] = useState(defaultValue);
  const [isEditing, setIsEditing] = useState(false);

  const startEditing = useCallback(() => {
    setIsEditing(true);
  }, []);

  const handleSave = useCallback(
    (finalValue: string) => {
      setValue(finalValue);
      setIsEditing(false);
      onSave?.(finalValue);
    },
    [onSave],
  );

  const handleCancel = useCallback(() => {
    setIsEditing(false);
    onCancel?.();
  }, [onCancel]);

  return { value, isEditing, startEditing, handleSave, handleCancel };
}
